export const invertedMessages = {
  Refresh: 'Refresh.ATTESTATIONS',
  "Couldn't Load": 'COULD_NOT_LOAD.ATTESTATIONS',
  Close: 'CloseLabel',
  Summary: 'CERTS_SUMMARY',
  History: 'CERTS_HISTORY',
  Entitlement: 'Ent_DISPLAYNAME.CERTIFICATIONS',
  'No actions or comments have been recorded for this certification yet.':
    'CERTS_LIST_NO_ACTIONS_MSG',
  "There's no summary available for this user.": 'CERTS_LIST_USER_SUMMARY_MSG',
  Children: 'CERTS_CHILDREN',
  Dependents: 'CERTS_DEPENDENTS',
  Trust: 'CERTS_TRUST',
  High: 'CERTS_HIGH',
  Conflicts: 'CERTS_CONFLICTS',
  Privilege: 'CERTS_PRIVILEGE',
  'Risk Priority': 'CERTS_RISK_PRIORITY',
  'Conflicting Job Functions': 'CERTS_CONFLICT_JOB_FUNCTIONS',
  'Load More': 'CERTS_LOAD_MORE',
  "The History tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_HISTORY',
  "The Summary tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_SUMMARY',
  "The Access Conflicts tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_SOD',
  "The Privilege tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_PRIVILEGE',
  "The Child Entitlements tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_CHILDREN',
  "The Dependent Entitlements tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_DEPENDENT',
  "The Child Roles tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_ENTITLEMENT',
  "Child entitlements are subsets of access and permissions that correlate to a parent entitlement. These aren't always revoked when a parent entitlement is revoked.":
    'CERTS_SIDEPANEL_CHILD_ENT_PERMISSION_LABEL',
  'Dependent entitlements are subsets of access and permissions that are directly mapped to a parent entitlement. If the parent entitlement is revoked, these are also revoked.':
    'CERTS_SIDEPANEL_CHILD_ENT_PERMISSION_LABEL',
};
